import { useSelector } from 'react-redux';

/**
 * Only to be used when unsure if organization level app has been mounted
 */
export const useUnsafeCurrentOrganizationId = () => {
  // FIXME: using the redux state here will create a dependency loop
  return useSelector((state: any) => state.ui.currentOrganizationId);
};

export const useCurrentOrganizationId = () => {
  const organizationId = useUnsafeCurrentOrganizationId();
  if (!organizationId) {
    throw new Error('used organization id outside organization');
  }
  return organizationId;
};
